import React from "react";

const ArrowIcon = ({ direction }) => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        className={`h-3 w-3 transition-transform ${direction === "desc" ? "rotate-180" : ""}`}
    >
        <polyline points="18 15 12 9 6 15" />
    </svg>
);

const SortableHeader = ({ active, direction = "asc", children, onClick }) => (
    <button
        type="button"
        onClick={onClick}
        className={`group inline-flex items-center gap-1.5 text-left text-xs font-medium transition-colors ${
            active ? "text-ink-700" : "text-ink-500 hover:text-ink-700"
        }`}
    >
        {children}
        <span
            className={`transition-opacity ${
                active ? "opacity-100" : "opacity-0 group-hover:opacity-50"
            }`}
        >
            <ArrowIcon direction={direction} />
        </span>
    </button>
);

export default SortableHeader;
